import React, { useState } from 'react';
import PropTypes from 'prop-types';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button } from '@src/components/ui/button/button';
import { axios } from '@src/lib/axios';
import { usePreventNavigationContext } from '@src/components/hooks/usePreventNavigationNative';
import { Warning, ReportProblem } from '@mui/icons-material';
import { SuccessCallout } from '../callouts/success-callout/success-callout';
import { InfoCallout } from '../callouts/info-callout/info-callout';

export const LinkStripeAccount = props => {
    const [loading, setLoading] = useState(false);
    const { enableNavigation } = usePreventNavigationContext();
    const payoutDetails = props.user?.payoutDetails || props.user?.PayoutDetails || {};

    const handleClick = async () => {
        try {
            setLoading(true);

            const response = await axios.post('/merchants/settings/onboard-to-stripe');

            if (props.onLink) {
                props.onLink();
            }
            enableNavigation();

            if (response.data?.data) {
                window.location.href = response.data.data;
            }
        } catch (err) {
            console.error('Stripe onboarding failed:', err);
        } finally {
            setLoading(false);
        }
    };

    const status = () => {
        if (payoutDetails?.status === 'linked_features_enabled') {
            return <SuccessCallout>Your account is linked.</SuccessCallout>;
        }

        if (payoutDetails?.status === 'ongoing_verification') {
            return (
                <InfoCallout>
                    Stripe account ongoing verification. Please refresh to check for updated status.
                </InfoCallout>
            );
        }

        return (
            <div className='tw-flex tw-items-center tw-gap-[12px] tw-p-[16px] tw-font-[500] tw-bg-[#FDD8353D] tw-rounded-[8px]'>
                <Warning className='tw-text-[24px] tw-min-w-[24px]' />
                {payoutDetails?.status === 'linked_features_not_enabled'
                    ? 'Almost there! Your onboarding is in progress, but a few more steps are required to complete it.'
                    : 'Account is not linked.'}
            </div>
        );
    };

    return (
        <>
            <div className='tw-text-black tw-flex tw-items-center tw-gap-6'>
                <div>
                    <img src='/assets/images/stripe_logo.svg' className='tw-w-[150px] tw-h-[71px]' alt='logo' />
                </div>
                <div className='tw-flex tw-items-center tw-gap-6'>{status()}</div>
            </div>
            {payoutDetails?.error ? (
                <div className='tw-flex tw-items-start tw-gap-[12px] tw-p-[16px] tw-bg-[#F4511E29] tw-rounded-[8px]'>
                    <ReportProblem className='tw-text-[24px] tw-text-[#BA1313]' />
                    <div>
                        <div className='tw-font-[500]'>We couldn’t link your account. </div>
                        <div className='tw-space-y-[24px]'>
                            <p>Please try again. If it still doesn’t work, contact customer service.</p>
                            <p>[BCAA Customer Service Contact Details]</p>
                            <p>You can continue using the platform as a customer for now.</p>
                        </div>
                    </div>
                </div>
            ) : null}
            {['linked_features_not_enabled', 'ongoing_verification', 'linked_features_enabled'].includes(
                payoutDetails?.status
            ) ? null : (
                <div>
                    <Button
                        onClick={handleClick}
                        variant='contained'
                        className='tw-text-[16px] tw-rounded-none tw-bg-primary-500 hover:tw-bg-primary-600'
                        disableElevation
                        endIcon={<OpenInNewIcon />}
                        loading={loading}
                    >
                        LINK ACCOUNT
                    </Button>
                </div>
            )}
            {payoutDetails?.status === 'linked_features_not_enabled' ? (
                <div>
                    <Button
                        onClick={handleClick}
                        variant='contained'
                        className='tw-text-[16px] tw-rounded-none tw-bg-primary-500 hover:tw-bg-primary-600'
                        disableElevation
                        endIcon={<OpenInNewIcon />}
                        loading={loading}
                    >
                        CONTINUE SETUP
                    </Button>
                </div>
            ) : null}
        </>
    );
};

LinkStripeAccount.propTypes = {
    user: PropTypes.shape({
        payoutDetails: PropTypes.shape({
            status: PropTypes.string,
            error: PropTypes.any
        }),
        PayoutDetails: PropTypes.shape({
            status: PropTypes.string,
            error: PropTypes.any
        }),
        stripeLoginUrl: PropTypes.string
    }).isRequired,
    onLink: PropTypes.func
};
